/**
 * Branded spinner component for loading states
 * @param {Object} props - Component props
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.size='sm'] - Size variant (sm, md)
 */
import React from 'react'
import PropTypes from 'prop-types'

const sizes = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6'
}

export function Spinner({ className = '', size = 'sm' }) {
  return (
    <div className={`inline-flex items-center justify-center ${className}`} role="status">
      <img
        src="/photowhim_spinner.png"
        alt="Loading..."
        className={`animate-spin ${sizes[size]}`}
        style={{ animationDuration: '1s' }}
      />
      <span className="sr-only">Loading...</span>
    </div>
  )
}

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md']),
  className: PropTypes.string
} 